export default "__VITE_ASSET__WCTzzkQb__"